import axios from "axios";

export const BOARD_GOVERNANCE_SUMMARY_URL =
  "/api/digital-risk/board-dashboard/governance-summary/";

export async function fetchBoardGovernanceSummary() {
  const { data } = await axios.get(BOARD_GOVERNANCE_SUMMARY_URL);
  return data;
}
